import { assetUrl } from 'src/single-spa/asset-url';
import { Component, OnInit, Input } from '@angular/core';
import { environment } from './../../services/util.service';

@Component({
  selector: 'asp-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  @Input() name: string;
  @Input() desc: string = 'icon';
  @Input() width: string = '2rem';
  @Input() height: string = '2rem';
  @Input() color: string = 'grey';
  @Input() path : string = '';

  iconSource: string;
  constructor() { }

  ngOnInit(): void {
    this.iconSource = assetUrl( 'icons/' + this.path + this.name);
  }
}
